<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Contactos" resource="contactos" primaryKey="idcontacto"
        :records="records" :meta="meta" :columns="columns" />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import ContactoService from "@/services/contacto.service";
import { contacto } from "@/models/contacto";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: contacto.filter(column => column.showOnList)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        ContactoService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
